import { render, staticRenderFns } from "./AdditionalDescription.vue?vue&type=template&id=73d1ae17&scoped=true"
import script from "./AdditionalDescription.vue?vue&type=script&lang=js"
export * from "./AdditionalDescription.vue?vue&type=script&lang=js"
import style0 from "./AdditionalDescription.vue?vue&type=style&index=0&id=73d1ae17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1ae17",
  null
  
)

export default component.exports